// extracted by mini-css-extract-plugin
export default {"link":"privacy_link__eKZJL","modalOverlay":"privacy_modalOverlay__OXCv4","modalContent":"privacy_modalContent__nMl+E","closeButton":"privacy_closeButton__1TIKs"};